module.exports = __webpack_public_path__ + "static/media/icon_189.b8817d6c.svg";